/**
 * Main Entry Point
 * DOM読み込み完了後に各機能を初期化
 */
document.addEventListener("DOMContentLoaded", () => {
  initLoading();

  // 慣性スクロール
  const lenis = new Lenis();
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  initFvSlider();
  initQualitySlider();
  initScrollToggle();
  initIntroParallax();
  initSidebarHeight();
  maskParallax();
  initScrollFadeOut();
  initStickyHeaderAdjustment();
  initContentsSlideIn();
  initRainEffect();
  adjustStickyPosition();
  setTimeout(() => {
    initCustomSticky();
  }, 500);
  initRpScroll();
});

/* ==========================================================================
   Features
   ========================================================================== */
/**
 * ページ読み込み時にトップへ強制移動
 * */
(function () {
  // ブラウザの標準的なスクロール復元機能を無効化
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  // 座標(0, 0)へ移動
  window.scrollTo(0, 0);
})();
/**
 * スクロール判定によるクラス付与
 * bodyに .is-scrolled をトグル
 */
const initScrollToggle = () => {
  const target = document.querySelector(".rp-main-contents");

  // 対象要素が存在しない場合は終了
  if (!target) return;

  const toggleScrollClass = () => {
    // 対象要素の画面上部からの相対位置（底辺）を取得
    const targetBottom = target.getBoundingClientRect().bottom;

    // 条件: スクロール量が30px超 かつ 対象要素がまだ画面上部より下にある
    const isScrolled = window.scrollY > 30 && targetBottom > 0;

    document.body.classList.toggle("is-scrolled", isScrolled);
  };

  window.addEventListener("scroll", toggleScrollClass, { passive: true });
};
/**
 * Loading
 */
const initLoading = () => {
  const loader = document.getElementById("js-loader");
  if (!loader) return;

  // 完了フラグ（二重実行防止）
  let isFinished = false;

  // スクロール操作をキャンセル
  function preventScroll(e) {
    e.preventDefault();
  }

  // スクロール禁止
  function lockScroll() {
    // passive: false で preventDefault 有効化
    window.addEventListener("wheel", preventScroll, { passive: false });
    window.addEventListener("touchmove", preventScroll, { passive: false });
  }

  // スクロール禁止解除
  function unlockScroll() {
    window.removeEventListener("wheel", preventScroll, { passive: false });
    window.removeEventListener("touchmove", preventScroll, { passive: false });
  }

  // ローディング終了処理
  const finishLoading = () => {
    if (isFinished) return;
    isFinished = true;

    // ロック解除
    unlockScroll();

    // フェードアウト
    loader.classList.add("is-hidden");

    // DOM削除
    loader.addEventListener(
      "transitionend",
      () => {
        loader.remove();
      },
      { once: true },
    );
  };

  // --- 実行フロー ---

  // 1. 即座にロック開始
  lockScroll();

  // 2. ロード完了で終了処理を実行
  window.addEventListener("load", () => {
    // ロード完了後、1500ミリ秒(1.5秒)待機してから関数を実行
    setTimeout(finishLoading, 1500);
  });

  // 3. 秒経過で強制的に終了処理を実行（上限設定）
  setTimeout(finishLoading, 5500);
};

/**
 * 雨エフェクトの同期と表示切り替え
 */
const initRainEffect = () => {
  const rainSwitches = document.querySelectorAll('input[name="rain-switch"]');
  const rainOverlay = document.querySelector(".rp-rain-layer");

  if (!rainOverlay || rainSwitches.length === 0) return;

  const toggleRain = (show) => {
    rainOverlay.style.display = show ? "block" : "none";
  };

  const syncSwitches = (e) => {
    const isChecked = e.target.checked;

    // 他のスイッチを同期
    rainSwitches.forEach((input) => {
      if (input !== e.target) input.checked = isChecked;
    });

    toggleRain(isChecked);
  };

  rainSwitches.forEach((input) => {
    input.addEventListener("change", syncSwitches);
  });
};

/**
 * PC版サイドバーの高さ調整（ウィンドウ高さに追従）
 */
const initSidebarHeight = () => {
  const sidebars = document.querySelectorAll(
    ".rp-pc-left-inner, .rp-pc-right-inner",
  );
  if (sidebars.length === 0) return;

  const adjustHeight = () => {
    const windowHeight = window.innerHeight;
    sidebars.forEach((sidebar) => (sidebar.style.height = `${windowHeight}px`));
  };

  adjustHeight();

  // リサイズ時はデバウンス処理推奨だが、簡易的にそのまま実装
  window.addEventListener("resize", adjustHeight, { passive: true });
};

/**
 * Sticky位置の動的計算と適用
 * 外部ライブラリ 'Sticky' に依存
 */
const initCustomSticky = () => {
  // 設定値定義
  const configs = [
    { selector: ".rp-pc-left-inner", mode: "top", val: 5 },
    { selector: ".rp-pc-right-inner", mode: "top", val: 5 },
    { selector: ".rp-pc-logo", mode: "top", val: 14 },
    { selector: ".rp-pc-rain-switch", mode: "top", val: 14 },
    { selector: ".rp-pc-lineup-1", mode: "bottom", val: 3 },
    { selector: ".rp-pc-lineup-2", mode: "bottom", val: 3 },
    { selector: ".rp-sticky-heading-1", mode: "top", val: 0 },
    { selector: ".rp-sticky-heading-2", mode: "top", val: 0 },
    { selector: ".rp-sticky-heading-3", mode: "top", val: 0 },
  ];

  // 計算ロジック
  const calculateMargin = (el, mode, percentage) => {
    const windowHeight = window.innerHeight;
    const elementHeight = el.offsetHeight;
    let calculatedTop = 0; // デフォルト値

    switch (mode) {
      case "top":
        calculatedTop = windowHeight * (percentage / 100);
        break;
      case "bottom":
        const bottomSpace = windowHeight * (percentage / 100);
        calculatedTop = windowHeight - elementHeight - bottomSpace;
        break;
      case "center":
        calculatedTop = (windowHeight - elementHeight) / 2;
        break;
    }
    return Math.max(0, calculatedTop);
  };

  // 各要素への適用処理 (単一要素対象)
  const applySticky = (selector, mode, percentage) => {
    // 単一要素を取得
    const el = document.querySelector(selector);
    if (!el) return;

    // 初期計算と属性セット
    let marginTop = calculateMargin(el, mode, percentage);
    el.setAttribute("data-margin-top", marginTop);

    // Stickyインスタンス生成
    // ライブラリの仕様上、戻り値は配列となるケースが多いため考慮
    const stickyInstances = new Sticky(selector);
    const targetInstance = stickyInstances[0]; // 対象は1つとみなす

    // リサイズ時の再計算 (デバウンス処理)
    let resizeTimer;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          // 要素の存在確認
          if (el) {
            const newMargin = calculateMargin(el, mode, percentage);
            el.setAttribute("data-margin-top", newMargin);

            // インスタンスのオプション更新
            if (targetInstance) {
              targetInstance.options.marginTop = newMargin;
              // 必要に応じて update() を実行
              if (typeof targetInstance.update === "function") {
                targetInstance.update();
              }
            }
          }
        }, 200);
      },
      { passive: true },
    );
  };

  // 一括実行
  configs.forEach((conf) => applySticky(conf.selector, conf.mode, conf.val));
};

/**
 * スクロール連動：特定エリア到達でのフェードアウト
 * .rp-container の底辺基準
 */
const initScrollFadeOut = () => {
  const triggerEl = document.querySelector(".rp-container");
  const targetEl = document.querySelector(".rain-drop-container");

  if (!triggerEl || !targetEl) return;

  const handleScroll = () => {
    const rect = triggerEl.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // 底辺が画面内にあるかどうかで判定
    const shouldFade = rect.bottom < windowHeight;
    targetEl.classList.toggle("is-faded", shouldFade);
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  handleScroll(); // 初期実行
};

/**
 * FVスライダー (Swiper)
 */
const initFvSlider = () => {
  const sliderEl = document.querySelector(".rp-fv-slider");
  if (!sliderEl) return;

  new Swiper(sliderEl, {
    loop: true,
    loopedSlides: 2,
    slidesPerView: "auto",
    speed: 3000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
};

/**
 * イントロアニメーションと視差効果
 * requestAnimationFrameによる最適化済み
 */
const initIntroParallax = () => {
  const intro = document.querySelector(".rp-intro");
  // 追加: 操作対象とトリガー要素の取得
  const fvCopy = document.querySelector(".rp-fv-copy");
  const introText = document.querySelector(".rp-intro-text");
  const mask = document.querySelector(".rp-fixed-mask-overlay");

  const body = document.body;
  let ticking = false;

  const onScroll = () => {
    const scrollPos = window.scrollY;
    // 追加: ウィンドウの高さを取得
    const windowHeight = window.innerHeight;

    // CSS変数セット（視差効果用）
    document.documentElement.style.setProperty("--scroll-y", `${scrollPos}`);

    // クラス切り替え
    if (intro) {
      const introRect = intro.getBoundingClientRect();
      const triggerPoint = windowHeight * 0.3;
      const isScrolledIntro = introRect.top < triggerPoint;

      body.classList.toggle("is-scrolled-intro", isScrolledIntro);

      const triggerPointMask = windowHeight * 0;
      const isScrolledMask = introRect.top < triggerPointMask;

      body.classList.toggle("is-scrolled-mask", isScrolledMask);
    }

    if (fvCopy && introText) {
      const textRect = introText.getBoundingClientRect();

      // 要素の下端が画面上端を超えたか判定（スクロールで消えた状態）
      const isHiddenAbove = textRect.bottom < windowHeight * 0.3;
      const isHiddenAboveMask = textRect.bottom < windowHeight * 0.3;

      if (isHiddenAbove) {
        fvCopy.classList.add("is-default");
        introText.classList.add("is-default");
      } else {
        // 再び画面内に戻ってきた場合はクラスを削除
        fvCopy.classList.remove("is-default");
        introText.classList.remove("is-default");
      }

      if (isHiddenAboveMask) {
        mask.classList.add("is-default");
      } else {
        // 再び画面内に戻ってきた場合はクラスを削除
        mask.classList.remove("is-default");
      }
    }

    ticking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true },
  );
};

/**
 * Scene用 視差効果
 *
 */
const maskParallax = () => {
  const parallaxImages = document.querySelectorAll(".js-mask-parallax-image");

  // 各画像の現在位置と目標位置を管理するMap
  const imageStates = new Map();

  // 初期化
  parallaxImages.forEach((img) => {
    imageStates.set(img, {
      current: 0,
      target: 0,
    });
  });

  // 線形補間関数 (Lerp)
  const lerp = (start, end, factor) => {
    return start + (end - start) * factor;
  };

  // アニメーションループ
  const animate = () => {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;

    parallaxImages.forEach((img) => {
      const state = imageStates.get(img);
      if (!state) return;

      const speed = parseFloat(img.getAttribute("data-speed")) || 0.1;
      const ease = parseFloat(img.getAttribute("data-ease")) || 0.08;

      const wrapper = img.parentElement;
      const rect = wrapper.getBoundingClientRect();
      const elementTop = rect.top + scrollY;
      const elementHeight = wrapper.offsetHeight;

      // 画面中央と要素中央の差分
      const screenCenter = scrollY + windowHeight / 2;
      const elementCenter = elementTop + elementHeight / 2;
      const diff = screenCenter - elementCenter;

      let targetPosition = 0;

      // 枠内で動く (Masking)
      // 枠に対して画像を中央寄せする初期位置を計算
      const initialOffset = (wrapper.offsetHeight - img.offsetHeight) / 2;
      targetPosition = initialOffset + diff * speed;

      // 慣性処理 (Lerp)
      state.target = targetPosition;
      state.current = lerp(state.current, state.target, ease);

      // 適用
      img.style.transform = `translate3d(0, ${state.current}px, 0)`;
    });

    requestAnimationFrame(animate);
  };

  animate();
};

/**
 * StickyヘッダーのTop位置調整
 * 関連要素の高さを合算して適用
 */
const adjustStickyPosition = () => {
  // --- 1. グローバルなヘッダー高さの計算 ---
  const shopifyHeader = document.getElementById("shopify-section-header");
  const spHeader = document.querySelector(".rp-sp-header");
  const spHeaderContainer = document.querySelector(".rp-sp-header-container");

  let totalHeight = 0;
  if (shopifyHeader) totalHeight += shopifyHeader.offsetHeight;

  if (spHeader) {
    const style = window.getComputedStyle(spHeader);
    if (style.display !== "none") totalHeight += spHeader.offsetHeight;
  }

  // spHeaderコンテナ調整
  if (spHeaderContainer && spHeader) {
    spHeaderContainer.style.height = `${spHeader.offsetHeight}px`;
  }

  // --- 2. 最初の要素を基準に全コンテナへ適用 ---
  const stickyContainers = document.querySelectorAll(".rp-sticky-container");
  if (stickyContainers.length === 0) return;

  // 最初のコンテナから基準となるターゲットを取得
  const firstTarget = stickyContainers[0].querySelector(".rp-sticky-heading");

  // 最初のターゲットが無い場合は処理中断
  if (!firstTarget) return;

  // 基準高さ（マスター）を取得
  const masterHeight = firstTarget.offsetHeight;

  stickyContainers.forEach((container) => {
    const target = container.querySelector(".rp-sticky-heading");

    // 対象がある場合のみtop位置を調整
    if (target) {
      target.style.top = `${totalHeight}px`;
    }

    // 全コンテナに1つ目の要素と同じ高さを適用
    container.style.height = `${masterHeight}px`;
  });
};

/**
 * リサイズ時のSticky位置再調整
 */
const initStickyHeaderAdjustment = () => {
  // リサイズ時も実行
  window.addEventListener(
    "resize",
    () => {
      // 頻繁な発火を防ぐためrequestAnimationFrameを利用しても良いが、
      // 既存ロジックに合わせ簡易実装とする
      adjustStickyPosition();
    },
    { passive: true },
  );
};

/* Aboutコンテンツ */
// 監視対象の要素を取得
const initContentsSlideIn = () => {
  const targets = document.querySelectorAll(".js-scroll-trigger");

  // IntersectionObserverのオプション設定
  const options = {
    root: null, // ビューポートをルートとする
    rootMargin: "0px 0px -60% 0px", // 画面下から**%の位置で発火させる
    threshold: 0, // 要素が少しでも入れば検知開始（rootMarginで位置は調整済み）
  };

  // オブザーバーのコールバック関数
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      // 指定位置を通過したら
      if (entry.isIntersecting) {
        // クラス付与でCSSアニメーション開始
        entry.target.classList.add("is-active");
        // 一度発火したら監視を解除（繰り返し動作させない場合）
        observer.unobserve(entry.target);
      }
    });
  }, options);

  // 各要素を監視開始
  targets.forEach((target) => {
    observer.observe(target);
  });
};

/**
 * Qualityスライダー (Swiper)
 */
const initQualitySlider = () => {
  // --- 共通機能: 画面に入ったら再生、出たら停止する監視役を作成 ---
  const observerOptions = {
    root: null, // ビューポートを基準
    rootMargin: "0px",
    threshold: 0, // 1ピクセルでも見えたら反応（必要に応じて0.5などで調整可）
  };

  const swiperObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Swiperのインスタンスは要素の.swiperプロパティに格納されています
      const swiperInstance = entry.target.swiper;

      if (!swiperInstance) return;

      if (entry.isIntersecting) {
        // 画面内に入った：再生開始
        swiperInstance.autoplay.start();
      } else {
        // 画面外に出た：停止
        swiperInstance.autoplay.stop();
      }
    });
  }, observerOptions);

  // --- 1. Quality Slider 1 ---
  const sliderEl1 = document.querySelector(".rp-quality-slider-1");
  if (sliderEl1) {
    const swiper1 = new Swiper(sliderEl1, {
      loop: true,
      loopedSlides: 2,
      slidesPerView: 1.2,
      centeredSlides: true,
      speed: 300,
      // 自動再生設定を追加（enabled: false で初期状態は停止にしておく）
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        enabled: false,
      },
      pagination: {
        el: ".rp-quality-pagination-1",
        clickable: true,
      },
    });
    // 監視対象に登録
    swiperObserver.observe(sliderEl1);
  }

  // --- 2. Quality Slider 2 ---
  const sliderEl2 = document.querySelector(".rp-quality-slider-2");
  if (sliderEl2) {
    const swiper2 = new Swiper(sliderEl2, {
      loop: true,
      loopedSlides: 2,
      slidesPerView: 1.2,
      centeredSlides: true,
      speed: 300,
      // 自動再生設定を追加
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        enabled: false,
      },
      pagination: {
        el: ".rp-quality-pagination-2",
        clickable: true,
      },
    });
    // 監視対象に登録
    swiperObserver.observe(sliderEl2);
  }

  // --- 3. Lineup Sliders (複数) ---
  const lineupSliders = document.querySelectorAll(".rp-lineup-slider");
  lineupSliders.forEach((sliderEl) => {
    const swiperLineup = new Swiper(sliderEl, {
      loop: true,
      loopedSlides: 2,
      slidesPerView: 1,
      centeredSlides: true,
      speed: 1300,
      // ここは元々の設定を維持しつつ enabled: false を推奨
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        waitForTransition: false,
        enabled: false, // 画面に入るまでは止めておく
      },
    });
    // 監視対象に登録
    swiperObserver.observe(sliderEl);
  });
};

/**
 * 指定した要素までヘッダー高を考慮してスクロール
 * @param {string} selector - ターゲットのIDセレクタ
 */
const precisionScrollTo = (selector) => {
  const target = document.querySelector(selector);
  const stickyHeader = document.querySelector('.rp-sticky-heading');
  if (!target) return;

  // 現在のヘッダー高とターゲット位置を計算する内部関数
  const getCalculatedPosition = () => {
    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // ヘッダーが存在すればその高さを取得、なければ0
    const offset = stickyHeader ? stickyHeader.offsetHeight : 0;
    
    // ターゲット位置 - ヘッダー高 - 余裕分(任意)
    return rect.top + scrollTop - offset + 20;
  };

  // 1回目のスクロール実行
  window.scrollTo({
    top: getCalculatedPosition(),
    behavior: 'smooth'
  });

  // スクロール停止後に lazy load 等によるズレを再補正
  let scrollEndTimeout;
  const adjustPosition = () => {
    window.clearTimeout(scrollEndTimeout);
    scrollEndTimeout = setTimeout(() => {
      const currentPos = window.pageYOffset || document.documentElement.scrollTop;
      const finalTargetPos = getCalculatedPosition();

      // 5px以上の差異があれば微調整（一度だけ実行）
      if (Math.abs(currentPos - finalTargetPos) > 5) {
        window.scrollTo({
          top: finalTargetPos,
          behavior: 'smooth'
        });
      }
      // イベントリスナーを解除してメモリを解放
      window.removeEventListener('scroll', adjustPosition);
    }, 150); // 停止判定の待機時間
  };

  window.addEventListener('scroll', adjustPosition);
};

/**
 * .rp-container 内のリンク監視
 */
const initRpScroll = () => {
  const container = document.querySelector('.rp-container');
  if (!container) return;

  container.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (href === '#' || !href) return;

    e.preventDefault();
    precisionScrollTo(href);
  });
};
